import React from 'react';
import Loader from 'react-loader-spinner';
import { createUseStyles } from 'react-jss';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

const useStyles = createUseStyles({
  loading: {
    composes: 'flexRow justifyCenter center',
    width: '100%',
  },
});

const Loading = ({ 
  isLoading,
  type = 'ThreeDots', 
  color = '#00BFFF',
  size = 75,
 }) => {

  const classes = useStyles();
  
  return (
    <div className={classes.loading}>
      <Loader
        type={type}
        color={color}
        height={size}
        width={size}
        visible={isLoading}
      />
    </div>
  );
}

export default Loading;